"use strict";const store={};exports.registerMixin=(name,mixin)=>{store[name]=mixin;};exports.mixins=store;